import noop from 'mn-utils/noop';
import React from 'react';
import map from 'mn-utils/map';
import formatTime from 'mn-utils/formatTime';
import upperFirst from 'mn-utils/upperFirst';
import toLower from 'mn-utils/toLower';
import {
  pushLocation,
} from '../../../../router';
import formatNumCurrency from '../../../../utils/formatNumCurrency';
import withState from '../../../../utils/withState';
import Caption from '../../../dumb/Caption/C';
import Tooltip from '../../../dumb/Tooltip/B';
import Col from '../../../dumb/Col/C';
import MenuForItem from '../../../dumb/Menu/ForItem';
import openPopupCancel from './openPopupCancel';
import openPopupEdit from "./openPopupEdit";
import {
  DisplayDataMerchant,
  DisplayIdMerchant,
  DisplayDateTimeMerchant,
  DisplayAmountMerchant
} from '../../../helpers/Display/DataDisplay';
import {TableStaticMerchant} from "../../../helpers/Table";
import {Box} from "@material-ui/core";
import {LINK_REFUND_DETAILS} from "../../../../constants/links";

const {
  getRFC3339,
} = formatTime;

const REFUND_STATUS_REQUESTED = 'requested';

const STATUS_MAP = {
  failed: 'cancelled',
  // pending: 'requested',
};

module.exports = withState(() => {
  return (state, props) => {
    const refunds = props.items || [];
    const callback = props.callback || noop;

    return (
      <Box mt="3rem">
        <div className="layoutRow fhaB fvaC">
          <Caption>Refunds</Caption>
        </div>
        <Box minHeight="500px" mt="2rem">
          <TableStaticMerchant
            list={refunds}
            rowCount={refunds.length}

            columns={[
              {
                minWidth: 150,
                label: 'Email',
                dataKey: 'email',
                dataHandler: ({email = ''}) => (
                  <DisplayDataMerchant>{email}</DisplayDataMerchant>
                )
              },
              {
                minWidth: 300,
                label: 'Refund ID',
                dataKey: 'id',
                dataHandler: ({id = ''}) => (
                  <DisplayIdMerchant>
                    {id}
                  </DisplayIdMerchant>
                )
              },
              {
                minWidth: 150,
                label: 'Date',
                dataKey: 'created_at',
                dataHandler: ({created_at}) => (
                  <DisplayDateTimeMerchant
                    date={created_at}
                  />
                )
              },
              {
                minWidth: 150,
                label: 'Amount',
                dataKey: 'amount',
                dataHandler: (row) => {
                  const currencyAmount = row.fiat_amount;
                  const currencyCode = row.fiat_code;

                  return (
                    <DisplayAmountMerchant
                      amount={currencyAmount}
                      symbol={currencyCode}
                      type="fiat"
                    />
                  )
                }
              },
              {
                minWidth: 200,
                label: 'Status',
                dataKey: 'status',
                dataHandler: (row) => {
                  const _status = toLower(row.status || '');
                  const status = STATUS_MAP[_status] || _status;

                  return (
                    <div
                      className={`f12 lh lts0em c0 cFFBF43.pending c2CE889.completed
                              c9C8FFF.requested cEE4F4F.canceled ` + status}
                    >
                      {upperFirst(status)}
                    </div>
                  )
                }
              },
            ]}
            actions={(row) => {
              return ([
                {
                  name: 'Details',
                  onClick() {
                    pushLocation({
                      path: `${LINK_REFUND_DETAILS}/${row.id}`,
                    });
                  },
                },
                ...(row.status === REFUND_STATUS_REQUESTED ? [
                  {
                    name: 'Edit',
                    onClick() {
                      openPopupEdit({
                        order_id: props.orderId,
                        refund_id: row.id
                      }, callback);
                    },
                  },
                  {
                    name: (<div className="cF00">Cancel</div>),
                    onClick() {
                      openPopupCancel(row.id, callback);
                    },
                  },
                ] : []),
              ])
            }}
          />
        </Box>
      </Box>
    );
  };
});
